/*******************************************************************************

  Project: Menoelle
  Author:  Primaline
  Date:    2022

********************************************************************************

TOC:
  Fix "Does not use passive listeners to improve scrolling performance" issue in the PageSpeed Insights
  
  jQuery document ready start
  Scroll to top
  Off canvas menu
  Header
  Dropdown Menu
  Lightbox for images and videos
  Responsive Videos
  Object Fit Images
  Contact Form 7 Fix
  Map
  Equal Heights
  Footer fix
  Fix group widths
  AJAX Load More
  Fix 100vh
  jQuery document ready end

*******************************************************************************/

// Fix "Does not use passive listeners to improve scrolling performance" issue in the PageSpeed Insights

jQuery.event.special.touchstart = {
  setup: function( _, ns, handle ) {
      this.addEventListener('touchstart', handle, { passive: !ns.includes('noPreventDefault') });
  }
};

jQuery.event.special.touchmove = {
  setup: function( _, ns, handle ) {
      this.addEventListener('touchmove', handle, { passive: !ns.includes('noPreventDefault') });
  }
};

jQuery( document ).ready(function($) {

  // Useful global variables
  var $adminBar = $('#wpadminbar'); 
  var adminBarEnabled = $adminBar.length ? true : false;

/* Scroll to top
------------------------------------------------------------------------------*/

  $(document).on( 'scroll', function(){
    if ($(window).scrollTop() > 200) {
      $('.c-scroll-to-top').addClass('show');
    } else {
      $('.c-scroll-to-top').removeClass('show');
    }
  });

  $('.c-scroll-to-top').on('click', function(event) {
    event.preventDefault();
    var verticalOffset = typeof(verticalOffset) != 'undefined' ? verticalOffset : 0;
    var element = $('body');
    var offset = element.offset();
    var offsetTop = offset.top;
    $('html, body').animate({scrollTop: offsetTop}, 500, 'linear');
  });

/* Mobile Menu Accordion
------------------------------------------------------------------------------*/

  $('ul.c-mobile-menu li').has('.mega-menu-wrapper').addClass('parentLi');
  $('ul.c-mobile-menu li .mega-menu-wrapper').addClass('sub-menu');

  $('ul.c-mobile-menu .parentLi > a').on('click', function(event){
    event.preventDefault();
    
    $('.sub-menu-title').html($(this).text());

    $('.js-nav').toggleClass('sub-menu-active');
    $('.nav-top-bar').toggleClass('visible');
    $(this).parent().find('div.sub-menu').toggleClass('visible');
  });

  $('.js-nav .arrow-back-wrapper').on('click', function (event) {
    $('div.sub-menu.visible').removeClass('visible');
    $('.nav-top-bar').removeClass('visible');
    $('.js-nav').removeClass('sub-menu-active');
  });

  // Blog sticky menu

  let stickyBlogWrapper = document.querySelector('.navigation-panel');
  if (stickyBlogWrapper) {
    let stickyItem = stickyBlogWrapper.querySelector('.share-sticky')
    let parent = stickyBlogWrapper.parentNode
    let scrollHeight = parent.scrollHeight
    let parentOffsetTop = parent.offsetTop

    window.addEventListener('scroll', e => {
      if ((window.scrollY - parentOffsetTop - 400) > (scrollHeight - parentOffsetTop)) {
        stickyItem.classList.add('hidden-sticky')
      } else {
        if (stickyItem.classList.contains('hidden-sticky')) {
          stickyItem.classList.remove('hidden-sticky')
        }
      }
    })
  }

  // Blog sticky menu

/* Header 
------------------------------------------------------------------------------*/

  // Hide header during the scroll to bottom
  if($('.js-header').data('behavior-when-scrolling-down') == 'hide') {
    // https://codingreflections.com/hide-header-on-scroll-down/
    var doc = document.documentElement;
    var w = window;

    var prevScroll = w.scrollY || doc.scrollTop;
    var curScroll;
    var direction = 0;
    var prevDirection = 0;

    var header = document.querySelector('.js-header');

    var checkScroll = function() {

      /*
      ** Find the direction of scroll
      ** 0 - initial, 1 - up, 2 - down
      */

      curScroll = w.scrollY || doc.scrollTop;
      if (curScroll > prevScroll) {
        //scrolled up
        direction = 2;
      }
      else if (curScroll < prevScroll) {
        //scrolled down
        direction = 1;
      }

      if (direction !== prevDirection) {
        toggleHeader(direction, curScroll);
      }

      prevScroll = curScroll;
    };

    var toggleHeader = function(direction, curScroll) {
      if (direction === 2 && curScroll > 52) {

        //replace 52 with the height of your header in px

        header.classList.add('-translate-y-full');
        prevDirection = direction;
      }
      else if (direction === 1) {
        header.classList.remove('-translate-y-full');
        prevDirection = direction;
      }
    };

    if(typeof(header) != 'undefined' && header != null) {
      window.addEventListener('scroll', checkScroll);
    }
  }


/* Dropdown Menu
------------------------------------------------------------------------------*/

  if ($('.c-hor-menu').length) {
    $('.c-hor-menu .menu-item-has-children > a').on('click', function (e) {
      e.preventDefault();
      if (!$(this).parent().hasClass('opened')) {
        $(this).closest('.c-hor-menu').find('.opened').removeClass('opened');
        $(this).parent().addClass('opened');
      }
      else {
        $(this).parent().removeClass('opened');
      }
    });
  }

  // Hide dropdown after click outside the menu
  $(document).on('click', function (event) {
    if (!$(event.target).closest('.c-hor-menu .menu-item-has-children a').length) {
      $('.c-hor-menu .menu-item-has-children').removeClass('opened');
    }
  }); 

  //popups
  $('.popup-close').on('click', function () {
    $(this).closest('.c-popup').fadeOut();
  });

  $(document).click(function (event) {
    var $target = $(event.target);
    if (!$target.closest('.popup-body').length && $('.c-popup').is(":visible")) {
      $('.c-popup').fadeOut();
    }
  });

  let popupNewsletter = document.cookie.split('; ').find(e => e.startsWith('popup-newsletter'));
  let popupWechseljahre = document.cookie.split('; ').find(e => e.startsWith('popup-wechseljahre'));

  if (!popupNewsletter && window.location.pathname == '/') {
    setTimeout(function () {
      $("#popup-newsletter").css("display", "flex").hide().fadeIn();

      let expiryDate = new Date();
      expiryDate.setMonth(expiryDate.getMonth() + 1);
      document.cookie = "popup-newsletter=true;expires=" + expiryDate.toGMTString();
    }, 7000);
  } else if (!popupWechseljahre && window.location.pathname.startsWith('/wechseljahre')) {
    setTimeout(function () {
      $("#popup-wechseljahre").css("display", "flex").hide().fadeIn();

      let expiryDate = new Date();
      expiryDate.setMonth(expiryDate.getMonth() + 1);
      document.cookie = "popup-wechseljahre=true;expires=" + expiryDate.toGMTString();
    }, 7000);
  }

/* Responsive Videos
/*******************************************************************************/

  fitvids({
    // players: 'iframe[src*="example.com"]'
  });

/* 9. Contact Form 7 Fix
/*******************************************************************************/

  $('.wpcf7-form p:empty').remove();

/* Map
/*******************************************************************************/

  $.each($('.dyn-map'), function(){

    var lat = $(this).data('lat');
    var long = $(this).data('long');
    var zoom = $(this).data('zoom');

    L.Icon.Default.imagePath = theme_settings.template_dir + '/assets/img/leaflet/';
    var mymap = new L.map($(this)[0], {
    scrollWheelZoom: false
    }).setView([lat, long], 16);

    // create custom icon
    var pinIcon = L.icon({
        iconUrl: theme_settings.template_dir + '/assets/img/leaflet/pin.svg',
        shadowUrl:  theme_settings.template_dir + '/assets/img/leaflet/marker-shadow.png',
        iconSize: [40, 50], // size of the icon
        iconAnchor:   [16, 50],
        shadowAnchor: [10, 39],
        popupAnchor:  [5, -48]
    });

    // Open Street Map
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        maxZoom: zoom
    }).addTo(mymap);

    if($(this).data('popup')) {
      L.marker([lat, long], {icon: pinIcon}).addTo(mymap)
      .bindPopup($(this).data('popup'))
      .openPopup();
    }

    // Open Street Map - Wikimedia
    // L.tileLayer('https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}{r}.png', {
    //     attribution: '<a href="https://wikimediafoundation.org/wiki/Maps_Terms_of_Use">Wikimedia</a>',
    //     maxZoom: zoom
    // }).addTo(mymap);

    // Open Street Map - Black and White
    /*
    L.tileLayer('http://{s}.tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        maxZoom: zoom
    }).addTo(mymap);
    */

    // Mapbox - remember to change accessToken
    /*
    L.tileLayer('https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}', {
        attribution: 'Map data © <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
        maxZoom: zoom,
        id: 'mapbox.streets',
        accessToken: 'pk.eyJ1IjoiYWRhbXBpbGNoIiwiYSI6ImNqbTY0aGlzeTB0eTEza280dGVpcjVnemMifQ.zZjr5GSWWpe4lYGBjvuz1A'
    }).addTo(mymap);
    */

    mymap.on('click', function() {
    if (mymap.scrollWheelZoom.enabled()) {
      mymap.scrollWheelZoom.disable();
      }
      else {
      mymap.scrollWheelZoom.enable();
      }
    });

  });

/* Equal Heights
------------------------------------------------------------------------------*/

  // Example:
  // $('.something').matchHeight();

  // Match Height compatibility with Lazy Load techniques
  // In most cases this code is not required if all images have width and haight dimmensions provided
  // function refreshMatchHeight() {
  //   $.fn.matchHeight._update();
  // }
  // $('img').on('load', _.throttle(refreshMatchHeight, 1000));
  $('.equal-height-block').matchHeight();

/* Footer fix
------------------------------------------------------------------------------*/

  function fixFooter() {
    if($('body').outerHeight() < $(window).outerHeight()) {
      var footerHeight = $('.js-footer').outerHeight();
      var bodyHeight = $('body').outerHeight();
      var windowHeight = $(window).outerHeight();
      var contentHeight = bodyHeight - footerHeight;
      $('.js-footer').css('min-height', windowHeight - contentHeight + 'px');
    }
  }

  fixFooter();
  $(window).on("debouncedresize", function( event ) { fixFooter(); });

/* Fix group widths
------------------------------------------------------------------------------*/

  $('.wp-block-group').each(function( index ) {
    if($(this).hasClass('alignfull')) {
      $(this).wrap( '<div class="wp-block-group-wrap alignfull"></div>' );
    }
    else if($(this).hasClass('alignwide')) {
      $(this).wrap( '<div class="wp-block-group-wrap alignwide"></div>' );
    }
    else {
      $(this).wrap( '<div class="wp-block-group-wrap"></div>' );
    }
  });

/* AJAX Load More
------------------------------------------------------------------------------*/

  $('.js-load-more').click(function(){
    var button = $(this);
    var content_place = $(this).parent();
    var data = {
      'action': 'ajax_load_more',
      'query': theme_settings.posts,
      'page' : theme_settings.current_page
    };

    if (!(button.hasClass('c-btn--post-loading-loader') || button.hasClass('c-btn--post-no-more-posts'))) {

      $.ajax({
        url : theme_settings.ajaxurl,
        data : data,
        type : 'POST',
        beforeSend : function ( xhr ) {
          button.addClass('c-btn--post-loading-loader').find('span').html(theme_settings.loading);
        },
        success : function( data ){
          var tempScrollTop = $(window).scrollTop();
          if( data.length ) {
            button.removeClass('c-btn--post-loading-loader').find('span').html(theme_settings.loadmore);
            $(data).insertBefore(content_place);
            theme_settings.current_page++;

            if ( theme_settings.current_page == theme_settings.max_page )
              button.removeClass('c-btn--post-loading-loader').addClass('c-btn--post-no-more-posts').find('span').html(theme_settings.noposts);
          } else {
            button.removeClass('c-btn--post-loading-loader').addClass('c-btn--post-no-more-posts').find('span').html(theme_settings.noposts);
          }
          $(window).scrollTop(tempScrollTop);
        }
      });
    }
  });

/* Fix 100vh
------------------------------------------------------------------------------*/
  
var customViewportCorrectionVariable = 'vh';

function setViewportProperty(doc) {
  var prevClientHeight;
  var customVar = '--' + ( customViewportCorrectionVariable || 'vh' );
  function handleResize() {
    var clientHeight = doc.clientHeight;
    if (clientHeight === prevClientHeight) return;
    requestAnimationFrame(function updateViewportHeight(){
      doc.style.setProperty(customVar, (clientHeight * 0.01) + 'px');
      prevClientHeight = clientHeight;
    });
  }
  handleResize();
  return handleResize;
}
window.addEventListener('resize', setViewportProperty(document.documentElement));

}); // end of jQuery code

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
/* ~~~~~~~~~~ Fancybox ~~~~~~~~~~ */
/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

(function($){

  $(document).ready(function() {

      $(".fancybox").fancybox();

      /* ~~~~~~~~~~ Youtube ~~~~~~~~~~ */

      $("[data-fancybox]").fancybox({
          youtube : {
              autoplay : 1
          }
      });

  });

})(jQuery);
